import { Countries } from 'shared/enums';
import { Touchpoints } from 'pages/calculator/MediaPlanning/Plan/Countries/hooks/useCalculateBudget';
import { postData } from 'api/services/mediaPlanning/utils';
import { ApiResponse } from 'api/services/mediaPlanning/types';
import { CAMPAIGN, CAMPAIGNv3 } from 'api/services/mediaPlanning/mediaPlanning';
import { CalculatedBudget } from 'store/planStore';

export const getEstimatedBudget = async ({
  body,
  countryISO,
}: {
  body: {
    campaignName: string;
    division: string;
    brand: string;
    category: string;
    mediaPlanId: string | null;
    campaignTargetGroup: string;
    campaignScenario: string;
    startDate: string;
    countryISO: string | null;
    campaignLength: number | null;
    segments: string[];
    touchpoints: Touchpoints;
    isTVIncluded?: boolean | null;
    isTVMandatory?: boolean;
  };
  countryISO?: Countries;
}) => {
  return postData<ApiResponse<CalculatedBudget[]>>(
    `/${CAMPAIGNv3}/calculate-digital`,
    body,
    {
      params: { countryISO },
    }
  );
};
